export function getMimeType(extensionType) {
  switch (extensionType.toLowerCase()) {
    case "pdf":
      return `application/pdf`;
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    default:
      return "application/octet-stream";
  }
}
